module.exports = __webpack_public_path__ + "static/media/tooth.9f50bf0d.svg";